<template>
    <section class="page-not-found">
        <div class="wrapper">
            <div class="page-not-found__logo">
               <img src="/templates/xhtml/krainaabc/src/assets/images/letters/krab.png" alt="Krab">
            </div>
            <div class="page-not-found__text">
                <IconPageNotFound/>
                <h4>Nie odnaleziono strony</h4>
                <p>Strona której szukasz nie jest dostępna lub nie została znaleziona</p>
                <button class="btn-success-arr" @click="returnHandle">
                    <span>Powrót do strony głównej</span>
                </button>
            </div>
        </div>
    </section>
</template>

<script>
import IconPageNotFound from '../elements/icons/IconPageNotFound.vue'
export default {
    name: "PageNotFound",
    components: {
        IconPageNotFound,
    },
    computed: {
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        }  
    },    
    methods: {
        returnHandle() {
            this.$router.push({
                name: "Categories",
                path: "/"
            });
        }
    },
    mounted() {
        window.gemius_event(
            '_view_',
            this.gemiusIdentifier
        );        
    }
};
</script>